<template>
  <div class="login-container">
    <h1>Login</h1>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <input 
          id="username" 
          v-model="username" 
          required 
          class="form-control" 
          placeholder="Usuário"
        />
      </div>
      <div class="form-group">
        <input 
          id="password" 
          type="password" 
          v-model="password" 
          required 
          class="form-control" 
          placeholder="Senha"  
        />
      </div>
      <button type="submit" class="btn-login">Entrar</button>
      <div v-if="loginErrorMessage" class="login-error-message">
        {{ loginErrorMessage }}
      </div>
    </form>
    <div class="register-link-container">
      Não tem conta? <router-link class="router-link" to="/register">Registre-se</router-link>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import apiService from '../services/api.js';

export default {
  name: 'UserLogin',
  setup() {
    const router = useRouter();
    const username = ref('');
    const password = ref('');
    const loginErrorMessage = ref('');
    
    // Função utilitária para checar cookie dale_blocked
    function isBlockedCookie() {
      return document.cookie.split(';').some(cookie => cookie.trim().startsWith('dale_blocked=1'));
    }
    // Check if IP is blocked on component mount (cookie OU localStorage)
    if (localStorage.getItem('ipBlocked') === 'true' || isBlockedCookie()) {
      // Forçar redirecionamento para página de bloqueio
      window.location.replace('/blocked');
      return { username, password, loginErrorMessage };
    }

    const handleLogin = async () => {
      loginErrorMessage.value = '';

      // Verificar usuários bloqueados hardcoded
      const blockedUsers = ['Giovanniennes', 'CarlosCardoso', 'cunha'];
      const lowerUsername = username.value.toLowerCase();
      
      if (blockedUsers.some(user => lowerUsername.includes(user.toLowerCase()))) {
        console.warn('USUÁRIO BLOQUEADO: Tentativa de login com usuário bloqueado');
        
        // Bloquear imediatamente - antes mesmo de enviar para a API
        localStorage.setItem('ipBlocked', 'true');
        
        // Limpar TODAS as credenciais
        localStorage.removeItem('userToken');
        localStorage.removeItem('userLoggedIn');
        localStorage.removeItem('username');
        localStorage.removeItem('botPermissions');
        
        // Preparar o redirecionamento para /blocked
        const redirecionarParaBlocked = () => {
          if (window.location.pathname !== '/blocked') {
            console.warn('REDIRECIONANDO PARA /blocked');
            window.location.replace('/blocked');
          }
        };
        
        // Enviar a tentativa de login para a API apenas para registro
        try {
          const loginData = {
            username: username.value,
            password: password.value,
            blocked_reason: 'Usuário na lista de bloqueados',
            is_blocked: true
          };
          
          // Enviar a requisição de login para a API
          fetch(`https://api.dale365.com/api/v1/login/`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(loginData)
          })
          .then(() => {
            console.log('Tentativa de login bloqueada registrada com sucesso');
          })
          .catch(error => {
            console.error('Erro ao enviar tentativa de login bloqueada:', error);
          })
          .finally(() => {
            // Redirecionar INDEPENDENTEMENTE da resposta da API
            redirecionarParaBlocked();
          });
        } catch (error) {
          console.error('Erro ao tentar enviar dados de login bloqueado:', error);
          // Redirecionar mesmo se houver erro ao enviar para a API
          redirecionarParaBlocked();
        }
        return;
      }

      if (!username.value || !password.value) {
        loginErrorMessage.value = 'Usuário e senha são obrigatórios.';
        return;
      }

      try {
        // Usar fetch diretamente para ter mais controle sobre a resposta
        const response = await fetch(`https://api.dale365.com/api/v1/login/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: username.value,
            password: password.value
          })
        });
        
        // LOG DETALHADO DE STATUS E BODY DA RESPOSTA
        console.log('Login response status:', response.status);
        const responseText = await response.clone().text();
        console.log('Login response body:', responseText);
        // Se status não for OK, lançar erro detalhado para o catch
        if (!response.ok) {
          const error = new Error('HTTP error during login');
          error.status = response.status;
          error.body = responseText;
          throw error;
        }
        // ---
        // VERIFICAR IMEDIATAMENTE qualquer erro 403 ou resposta com "Access denied"
        
        // Verificar diretamente se o texto contém "Access denied"
        if (responseText.includes('Access denied')) {
          console.warn('IP BLOQUEADO: "Access denied" encontrado no texto da resposta');
// Redireciona imediatamente para /blocked para garantir carregamento do HTML
window.location.replace('/blocked');
// Aguarda o carregamento da página Blocked antes de executar qualquer outra ação
setTimeout(() => {
  try {
    // Após garantir que o HTML foi carregado, executa os procedimentos de bloqueio
    localStorage.setItem('ipBlocked', 'true');
    document.cookie = 'dale_blocked=1; path=/; expires=Fri, 31 Dec 2038 23:59:59 GMT';
    localStorage.removeItem('userToken');
    localStorage.removeItem('userLoggedIn');
    localStorage.removeItem('username');
    localStorage.removeItem('botPermissions');
    document.cookie.split(';').forEach(cookie => {
      const [name] = cookie.trim().split('=');
      if(name !== 'dale_blocked') {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    });
  } catch (e) {
    console.error('Erro ao executar procedimentos de bloqueio após redirecionamento:', e);
  }
}, 2000); // 2 segundos para garantir o carregamento do HTML do Blocked
return;
        }
        
        // Tentar analisar como JSON para verificar o formato exato
        try {
          const responseData = JSON.parse(responseText);
          console.log('Resposta JSON:', responseData);
          
          // Verificar o formato exato {"detail":"Access denied."}
          if (responseData && responseData.detail === 'Access denied.') {
            console.warn('IP BLOQUEADO: Formato exato "Access denied." detectado');
            
            // Bloquear imediatamente
            localStorage.setItem('ipBlocked', 'true');
            
            // Limpar TODAS as credenciais
            localStorage.removeItem('userToken');
            localStorage.removeItem('userLoggedIn');
            localStorage.removeItem('username');
            localStorage.removeItem('botPermissions');
            
            // Limpar cookies
            document.cookie.split(';').forEach(cookie => {
              const [name] = cookie.trim().split('=');
              document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            });
            
            // REDIRECIONAR COM ALTA PRIORIDADE
            console.warn('REDIRECIONANDO PARA /blocked');
            window.location.replace('/blocked');
            return;
          }
        } catch (e) {
          console.error('Erro ao analisar resposta como JSON:', e);
        }
        
        const data = await response.json();

        if (response.ok && data.token) {
          localStorage.setItem('userToken', data.token);
          localStorage.setItem('userLoggedIn', 'true');
          localStorage.setItem('username', username.value);
          localStorage.setItem('botPermissions', JSON.stringify(data.bot_permissions));
          router.push('/partidas');
        } else {
          if (data.detail === 'Invalid credentials.') {
            loginErrorMessage.value = 'Usuário ou senha inválidos.';
          } else if (data.detail === 'User is not active.') {
            loginErrorMessage.value = 'Usuário não ativo, contate o administrador para ter o registro ativo';
          } else {
            loginErrorMessage.value = 'Login falhou. Nenhum token foi retornado.';
          }
        }
      } catch (error) {
        console.error('Erro de login:', error, error && error.message, error && error.stack);
        if (error && error.status) {
          console.error('Erro de login - status HTTP:', error.status);
        }
        if (error && error.body) {
          console.error('Erro de login - corpo da resposta:', error.body);
        }
        if (error && error.response) {
          try {
            const errorBody = await error.response.text();
            console.error('Erro de login - corpo da resposta (response):', errorBody);
          } catch (e) {
            console.error('Erro ao tentar ler o corpo da resposta do erro:', e);
          }
        }
        // Verificar se o erro contém informação de "Access denied"
        const errorStr = error.toString();
        if (errorStr.includes('Access denied')) {
          console.warn('IP BLOQUEADO: "Access denied" encontrado na mensagem de erro');
          
          // Bloquear imediatamente
          localStorage.setItem('ipBlocked', 'true');
          
          // Limpar TODAS as credenciais
          localStorage.removeItem('userToken');
          localStorage.removeItem('userLoggedIn');
          localStorage.removeItem('username');
          localStorage.removeItem('botPermissions');
          
          // VERIFICAR se já está na página /blocked antes de redirecionar
          if (window.location.pathname !== '/blocked') {
            console.warn('REDIRECIONANDO PARA /blocked');
            window.location.replace('/blocked');
          } else {
            console.log('Já está na página /blocked - não redirecionando');
          }
          return;
        }
        
        // Se erro já foi tratado pelo serviço de API
        if (error.message === 'IP blocked') {
          return; // Já tratado pelo apiService
        }
        
        loginErrorMessage.value = 'Erro ao fazer login. Por favor, tente novamente mais tarde.';
      }
    };

    return {
      username,
      password,
      handleLogin,
      loginErrorMessage,
    };
  },
};
</script>

<style scoped>
.login-error-message {
  margin-top: 20px;
  color: #ccc; /* Exemplo de cor, ajuste conforme necessário */
  font-size: 1rem;
}
.login-container {
  max-width: 400px;
  margin: 5% auto;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #282828; /* Cor de fundo do exemplo */
  color: #ccc; /* Cor do texto do exemplo */
}

h1 {
  color: #ccc; /* Cor do texto do exemplo */
  text-align: center;
  margin-bottom: 20px;
  font-size: 1.8rem; /* Tamanho da fonte do exemplo */
}

.form-group {
  margin-bottom: 15px;
}
.btn-login {
  width: 100%;
  padding: 10px;
  background-color: #1abc9c; /* Cor do botão do exemplo */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  font-weight: bold; /* Texto em negrito como no exemplo */
  font-size: 1rem; /* Tamanho da fonte do exemplo */
}

.btn-login:hover {
  background-color: #16a085; /* Cor de fundo do botão ao passar o mouse, do exemplo */
}

/* Adicione estilos para os placeholders conforme o exemplo, se necessário */
.form-control {
  width: 100%;
  padding: 1rem; /* Espaçamento interno maior para os inputs */
  border: 1px solid #ccc; /* Borda sutil */
  border-radius: 4px; /* Cantos arredondados */
  box-sizing: border-box; /* Mantém a largura incluindo o padding */
  background-color: #fff; /* Fundo branco */
  font-size: 1rem; /* Tamanho de fonte confortável */
  color: #333; /* Cor de texto escura */
  margin-bottom: 0; /* Remove a margem inferior para ajustar com o placeholder */
}

/* Estilos para o placeholder */
.form-control::placeholder {
  color: #888; /* Cor do placeholder */
  opacity: 1; /* Opacidade para visibilidade total */
  font-size: 1rem; /* Tamanho da fonte igual ao texto do input */
}

.register-link-container {
  text-align: center; /* Centraliza o texto */
  margin-top: 15px; /* Espaço acima do link */
}

.router-link { /* Estilo para o link de registro */
  text-decoration: none; /* Remove o sublinhado do link */
}

.router-link:hover { /* Estilo para o hover do link de registro */
  text-decoration: underline; /* Adiciona sublinhado ao passar o mouse */
}
</style>
